import { observer } from 'mobx-react-lite'
import React from 'react'

// evertel
import { Row, Col, Card, CardBody } from '@evertel/web/ui'
import { Document, WidgetsProvider } from '@evertel/schema-parser'
import { DocumentServiceProvider } from '@evertel/service'
import { WriteWidgets } from '../schema-widgets'
import { SchemaBuilderController } from '../../controller'


interface SchemaBuilderPreviewProps {
    controller: SchemaBuilderController
}

const SchemaBuilderPreview: React.FC<SchemaBuilderPreviewProps> = observer(({
    controller: schemaBuilderController
}) => {

    return (
        <Card style={{minHeight: 400}}>
            <CardBody>
                <DocumentServiceProvider services={[{ id: 'meta', value: { } }]}>
                    <WidgetsProvider value={WriteWidgets}>
                        <Document
                            layout="full"
                            schemaId={schemaBuilderController.id}
                            schema={schemaBuilderController.schema}
                        />
                    </WidgetsProvider>
                </DocumentServiceProvider>
            </CardBody>
        </Card>
    )
})

export { SchemaBuilderPreview }
